import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.671 7.193c-.727-.773-2.738-.458-3.21-.38a8.2 8.2 0 0 1-1.343-1.768 7.9 7.9 0 0 0 .459-2.32c0-.707-.282-1.467-1.068-1.467a.8.8 0 0 0-.662.386c-.334.577-.203 1.77.334 2.975-.314.884-.766 2.162-1.363 3.197-.805.32-2.515 1.107-2.68 1.978a.74.74 0 0 0 .237.695c.19.168.44.258.694.249 1.029 0 2.057-1.428 2.752-2.654q1.202-.41 2.45-.642c1.088.95 2.057 1.094 2.549 1.094.668 0 .917-.288 1.008-.53a.82.82 0 0 0-.157-.813m-.707.498c-.033.19-.276.38-.728.282a3.6 3.6 0 0 1-1.428-.72c.354-.06 1.18-.138 1.763-.027.21.04.452.157.393.465M5.273 1.893a.26.26 0 0 1 .23-.144c.248 0 .3.302.3.55a7.7 7.7 0 0 1-.327 1.75c-.42-1.114-.36-1.887-.203-2.156m-.06 5.445q.365-.764.65-1.56.393.623.89 1.166-.78.156-1.54.394M3.57 8.464c-.661 1.062-1.31 1.73-1.69 1.73a.27.27 0 0 1-.17-.059.24.24 0 0 1-.085-.242c.072-.38.825-.93 1.945-1.429"
    }, null, -1)
  ])))
}
export default { render: render }